/* eslint sort-keys: 1 */

import { TMarketplace } from '@com/core/common/types/config';
import { baseConfig, IMG_BASE } from '@com/core/common/baseConfig';
import { TMarketplaceConfig } from '../common/types/config';

export const IS_DOCKER_NON_DEV = process.env.DOCKER === 'yes' && process.env.ENV !== 'dev';
// eslint-disable-next-line no-underscore-dangle
export const MARKETPLACE = process.env._MARKETPLACE as TMarketplace;
// eslint-disable-next-line no-underscore-dangle
export const DOMAIN = process.env.ENV !== 'prod' ? `${MARKETPLACE}stg` : MARKETPLACE;

export const IS_BROWSER = typeof window !== 'undefined';
export const SVC_ENDPOINT = IS_BROWSER ? '/_svc' : `https://api-external.${DOMAIN}.com/_svc`;

const marketplaceConfig: TMarketplaceConfig = {
    ...baseConfig,
    commonHeaders: {
        ...baseConfig.commonHeaders,
        'X-MP': 'kul',
    },
    endpoints: {
        ...baseConfig.endpoints,
        catalog:
            IS_DOCKER_NON_DEV && !IS_BROWSER
                ? 'http://catalog-kul-noratelimit/api'
                : SVC_ENDPOINT.replace('/_svc', '/_svc/catalog-kul/api'),
    },
    regions: {
        ...baseConfig.regions,
        ae: {
            ...baseConfig.regions.ae,

            codLimit: 5000,
            enabled: true,
            freeDeliveryCap: 100,
            help: {
                ar: 'https://kul.zendesk.com/hc/ar',
                en: 'https://kul.zendesk.com/hc/en-us',
            },
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'care@kul.com',
            supportPhone: '80058522',
        },
        eg: {
            ...baseConfig.regions.eg,
            codLimit: 5000,
            enabled: false,
            freeDeliveryCap: 100,
            help: {
                ar: 'https://kul.zendesk.com/hc/ar',
                en: 'https://kul.zendesk.com/hc/en-us',
            },
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'care@kul.com',
            supportPhone: 'xxxxx',
        },
        sa: {
            ...baseConfig.regions.sa,
            codLimit: 5000,
            enabled: true,
            freeDeliveryCap: 100,
            help: {
                ar: 'https://kul.zendesk.com/hc/ar',
                en: 'https://kul.zendesk.com/hc/en-us',
            },
            paymentMethods: ['mastercard', 'mada', 'visa', 'cod', 'amex'],
            supportEmail: 'care@kul.com',
            supportPhone: '8001160123',
        },
    },

    urls: {
        ...baseConfig.urls,
        appStore: 'xxx',
        colorSwatches: 'https://a.nooncdn.com/cms/pages/20181025/0ce4c3a5d392155933d4571ef91fc179',
        facebook: 'https://www.facebook.com/helloKUL/',
        googlePlay: 'xxx',
        imgBase: `${baseConfig.urls.imgBase}/kul/images/`,
        instagram: 'https://www.instagram.com/kul/',
        linkedin: '',
        supportInfo: {
            careers: 'https://www.linkedin.com/company/nooncom/jobs/',
            partners: `https://login.noon.partners/en/register`,
            privacyPolicy: '/privacy-policy',
            termsOfSale: '/terms-of-sale',
            termsOfUse: 'https://login.noon.partners/en/register',
            warrantyPolicy: '/warranty-policy',
        },
        twitter: 'https://twitter.com/helloKUL/',
    },

    // eslint-disable-next-line sort-keys
    assets: {
        ...baseConfig.assets,
        icons: {
            ...baseConfig.assets.icons,
            address: ``,
            arrowDiagonal: `${IMG_BASE}/kul/icons/arrowDiagonal.svg`,
            cart: `${IMG_BASE}/kul/icons/cart-white.svg`,
            cartBlack: `${IMG_BASE}/kul/images/icons/cart-black.svg`,
            cartBrand: `${IMG_BASE}/kul/icons/cart-brand.svg`,
            cartWhite: '',
            check: ``,
            checkboxChecked: ``,
            checkboxUnchecked: ``,
            checkmark: `${IMG_BASE}/kul/images/icons/check.svg`,
            chevronDown: `${IMG_BASE}/kul/icons/chevron-down.svg`,
            claims: ``,
            closeXBlack: `${IMG_BASE}/kul/icons/x-black.svg`,
            closeXWhite: `${IMG_BASE}/kul/icons/x-white.svg`,
            collectionPointsToggle: ``,
            coupon: `${IMG_BASE}/kul/icons/coupon.svg`,
            credits: ``,
            edit: ``,
            favicon: `${IMG_BASE}/kul/icons/favicon.ico`,
            gift: `${IMG_BASE}/kul/icons/gift.svg`,
            globe: ``,
            hamburger: ``,
            help: '',
            home: ``,
            info: `${IMG_BASE}/kul/icons/info.svg`,
            magnifyingGlass: ``,
            nextDayDelivery: '',
            nonReturnable: `${IMG_BASE}/kul/images/icons/non-returnable.svg`,
            noonPay: '',
            orders: `${IMG_BASE}/kul/images/icons/orders.svg`,
            payments: ``,
            preferences: '',
            prepaidOnly: '',
            profile: ``,
            returns: ``,
            search: `${IMG_BASE}/kul/icons/search.svg`,
            share: `${IMG_BASE}/kul/icons/share.svg`,
            shipment: ``,
            shipmentMethod: {
                dd: '',
                fallback: '',
                sc: '',
                sdd: '',
            },
            shop: ``,
            signOut: ``,
            trash: `${IMG_BASE}/kul/icons/remove-grey.svg`,
            user: `${IMG_BASE}/kul/icons/user.svg`,
            wishList: `${IMG_BASE}/kul/icons/wishlist.svg`,
            wishListAdded: `${IMG_BASE}/kul/icons/wishlist-added.svg`,
            wishListBlack: `${IMG_BASE}/kul/icons/wishlist-black.svg`,
        },
        images: {
            ...baseConfig.assets.images,
            addressCollectionIndicator: ``,
            addressLatLngIndicator: ``,
            addressesEmptySlate: ``,
            bankTransferEmpty: '', // transfer list page empty status image for BlankSlate
            cartEmpty: `${IMG_BASE}/kul/images/empty-cart-v2.svg`,
            chevronRight: '',
            chevronRightWhite: '',
            claimsEmptySlate: ``,
            claimsSuccessSlate: ``,
            claimsTypeChecked: ``,
            claimsTypeDamage: ``,
            claimsTypeProtection: ``,
            claimsTypeUnchecked: ``,
            defaultMap: ``,
            defaultProductPlaceholder: ``,
            emptyDiscovery: `${IMG_BASE}/kul/images/empty-discovery.svg`,
            emptySearch: `${IMG_BASE}/kul/images/empty-search-v2.svg`,
            error404: `${IMG_BASE}/kul/images/error-404-v2.svg`,
            error500: `${IMG_BASE}/kul/images/error-500.svg`,
            fulfilmentExpressAr: `${IMG_BASE}/kul/images/express-ar.svg`,
            fulfilmentExpressEn: `${IMG_BASE}/kul/images/express-en.svg`,
            fulfilmentPreOrderAr: ``,
            fulfilmentPreOrderEn: ``,
            fulfilmentMarketplaceEn: '',
            fulfilmentMarketplaceAr: '',
            logoBG: '', // Big logo that's behind the login page
            mapCollectionPointLocker: ``,
            mapCollectionPointPickup: ``,
            mapCollectionPointToggle: ``,
            mapLandmarkPin: ``,
            mapLocateMeAr: ``,
            mapLocateMeEn: ``,
            openGraphImage: `${IMG_BASE}/kul/images/opengraph-image-kul-v2.svg`,
            paymentEmptySlate: '',
            returnSuccess: '', // returns page success status image for BlankSlate
            returnablesEmptyState: '',
            returnsEmptyState: '', // returns page empty status image for BlankSlate
            secure: '',
            transferRequestSuccess: '', // transfer request page success status image for BlankSlate
        },
    },
    headerSupportBar: false,

    // eslint-disable-next-line sort-keys
    gtm: {
        ...baseConfig.gtm,
        gaID: 'UA-84507530-18',
        gtmID: 'GTM-54ZJJDL',
        optimizeID: 'xxx',
    },

    // eslint-disable-next-line sort-keys
    enabledFeatures: {
        etracking: true,
        loyalty: false,
        fingerprinting: true,
    },

    etracking: {
        url: 'https://etracker.noon.com/track',
        id: 'kul',
    },
};

export default marketplaceConfig;
